import {resetSmartWizard} from "@/helpers/smart-wizard-helper";
import {refreshLayerByName, removeLayer} from "@/helpers/ol-layer-helper";
import {getDefaultName} from "@/helpers/geo-json-helper";
import {resetFileUploads} from "@/helpers/file-upload-helper";
import {resetDatePicker} from "@/helpers/date-picker-helper";
import $ from "jquery";
import moment from "moment/moment";

export function processWfstRequest() {
    document.querySelector('wizard-send-message').classList.remove('d-none')
    document.querySelector('wizard-nav').classList.add('d-none')
    document.querySelector('wizard-tab').classList.add('d-none')

    resetSmartWizard()
    removeLayer(getDefaultName())
    removeLayer('suspected')
    refreshLayerByName(window.wizard.Layer)
    resetFileUploads()
    resetDatePicker()

    const linkedLayer = window.wizard.LinkedLayer
    if(linkedLayer.Layer !== null) {
        refreshLayerByName(linkedLayer)
    }

    document.querySelectorAll('input').forEach( element => {
        if(element.type === 'text') {
            element.value = ''
        }
    })
    document.querySelectorAll('textarea').forEach( element => {
        element.value = ''
    })

    document.querySelectorAll('.list-group-item').forEach( element => {
        element.classList.remove('active')
    })

    let selectedItem = `
            <div class="alert alert-secondary alert-dismissible fade show">
                <span class="fa fa-circle"></span> Kies een object in de kaart
            </div>`
    if(window.categoryNameLinked === undefined) {
        selectedItem = `
            <div class="alert alert-secondary alert-dismissible fade show">
                <span class="fa fa-map-marker"></span> Klik op de kaart of voer een adres in
            </div>`
    }
    const selectedItemElement = document.getElementById('selectedItem')
    if(selectedItemElement) {
        selectedItemElement.innerHTML = selectedItem
    }

    window.wizard.Items.map( item => {
        item.Items.map( childItem => {
            if (childItem.AttributeTypeID !== null) {
                const element = document.querySelector('form-element[data-form-attribute-id="' + childItem.FormAttributeID + '"]')
                switch (childItem.AttributeTypeID) {
                    case 12:
                        const childElement = element.querySelector('form-domain-list-item')
                        if(childElement && childElement.dataset.parentName !== 'undefined') {
                            element.querySelector('form-domain-list-single').innerHTML = '';
                        }
                        break;
                    case 13:
                        element.querySelector('.list-group-item[data-value="' + childItem.DefaultValue + '"]').click()
                        break;
                    case 60:
                        $('#iptNewNotificationDate-' + childItem.AttributeID).datepicker("update",moment().format('DD-MM-YYYY'));
                        break;
                    default:

                        break;
                }
            }
        })
    })
}
